import * as yup from 'yup';

export const schema = yup.object({
  code: yup.string().nullable(),
  name: yup.string().required('必須です'),
  packingStyle: yup.string().nullable(),
  weightKgPerUnit: yup
    .number()
    .positive('正の数で入力してください')
    .typeError('数値で入力してください')
    .nullable()
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value)),
  volumeM3PerUnit: yup
    .number()
    .positive('正の数で入力してください')
    .typeError('数値で入力してください')
    .nullable()
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value)),
  lotNumber: yup.string().nullable(),
});
